import React, { Component } from 'react'
import { connect } from 'react-redux'
// Dialog dependencies
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import Axios from 'axios'
import Translated from "../../../components/Translated/Translated";
import translator from "../../../utils/translator";

function isObject(value) {
    return value && typeof value === 'object' && value.constructor === Object;
}

export class DeleteProjectTableRow extends Component {
    state = {
        dialog: null,
        transfer_project_to_production: false, // Using to tell the program which server this project will be transferred to. 
        transfer_project_to_development: false // Using to tell the program which server this project will be transferred to.
    }

    // -- INCOMPLETE --
    // Come back to this later because i'm currently just rushing because i wasted so much time on this im frustrated. It's not working and i'll just waste more time since i dont have a calm mind. Can't debug effectively if im rushing or not calm.
    toggleCheckBox = async (checkbox_name) => {
        console.log("checkbox_name")
        switch (checkbox_name) {
            case "development":
                await this.setState({ transfer_project_to_development: !this.state.transfer_project_to_development, transfer_project_to_production: false })
                console.log("Development state ", this.state.transfer_project_to_development)
                break;

            case "production":
                await this.setState({ transfer_project_to_production: !this.state.transfer_project_to_production, transfer_project_to_development: false })
                console.log("Production state ", this.state.transfer_project_to_production)
                break;
        }
    }

    delete_project = async () => {
        try {
            // Check which environmnet the user wants to transfer this project to
            let delete_project_API_URL = this.props.API_URL + "/projects/delete-project"
            let data = {
                projectId: this.props.project_ID,
                token: localStorage.getItem('token'),
                trendId: localStorage.getItem('trendId'),
            }
            console.log("here is the data object value before we send it to the backend ", data)
            let delete_project_API_response = await Axios.post(delete_project_API_URL, data)

            let dialog = <Dialog open={true} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title set-price-dialog-header">
                    <Translated section="Admin Delete Project" label="confirm_delete_dialog_title" />{" "}
                </DialogTitle>
                <DialogContent style={{ paddingRight: "10em" }}>
                    <React.Fragment>
                        <DialogContentText>
                            {isObject(delete_project_API_response.data.api_response) ? delete_project_API_response.data.api_response.success : delete_project_API_response.data.api_response}

                        </DialogContentText>
                        <Button style={{ marginLeft: "10em" }} id="set-price-close-button" onClick={() => this.setState({ dialog: null })} color="primary">
                            <Translated section="Misc" label="ok_btn" />
					    </Button>

                    </React.Fragment>
                </DialogContent>
            </Dialog>
            this.setState({ dialog })
        } catch (error) {
            console.log("here is the error message when transferring a project", error.message)
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.state.dialog}
                <tr class="project-search-table-row">
                    <td id="tbody-header" scope="row">
                        {this.props.project_name}
                    </td>
                    <td>{this.props.warehouse_number}</td>
                    <td>{this.props.account_name}</td>
                    <td>{this.props.project_status ? translator("Misc", "active_label") : translator("Misc", "archived_label")}</td>
                    <td>
                        <button
                            onClick={() => this.setState({
                                dialog:
                                    <Dialog open={true} aria-labelledby="form-dialog-title">
                                        <DialogTitle id="form-dialog-title set-price-dialog-header">
                                            <Translated section="Admin Delete Project" label="confirm_delete_dialog_title" />{" "}
                                        </DialogTitle>
                                        <DialogContent style={{ paddingRight: "10em" }}>
                                            <React.Fragment>
                                                <DialogContentText>
                                                    <Translated section="Admin Delete Project" label="confirm_delete_dialog_message" /> <br />
                                                    {this.props.project_name}
                                                </DialogContentText>
                                                <Button style={{ marginLeft: "10em" }} id="set-price-close-button" onClick={() => this.setState({ dialog: null })} color="primary">
                                                    <Translated section="Misc" label="cancel_btn" />
					                        </Button>
                                            <Button style={{ marginLeft: "10em" }} id="set-price-close-button" onClick={() => this.delete_project()} color="primary">
                                                <Translated section="Misc" label="yes_btn" />
					                        </Button>
                                            </React.Fragment>
                                        </DialogContent>
                                    </Dialog>
                            })}
                            type="button"
                            class="btn btn-outline-primary"
                            style={{ whiteSpace: "nowrap", paddingRight: "6em" }}
                        >
                            <Translated section="Misc" label="delete_label" />
                        </button>
                    </td>
                </tr>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => ({
    API_URL: state.APIUrl,
    selected_language: state.selected_language
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteProjectTableRow)
